import { featureFlags, permissions } from '@dvag/dfs-constant-config';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { useGetPolicies } from './useGetPolicies';

export const usePermission = (permission: (typeof permissions)[keyof typeof permissions]) => {
  const useNewPermissionsApi = useFeatureIsOn(featureFlags.canUsePermissionsApi);
  const hasPermission = !!permission;

  const policies = useGetPolicies({
    enabled: useNewPermissionsApi && hasPermission,
  });

  if (!useNewPermissionsApi) {
    return true;
  }

  const policyList = policies.data?.policies;

  return Array.isArray(policyList) && policyList.includes(permission);
};
